import React, { ReactElement, useContext } from 'react';
import Button from '@/features/marketing/components/Button';
import { HeaderContext } from '@/shared/contexts/Header';
import menuCloseBtnIcon from '@/assets/icons/front/menu-close-btn.svg';
import menuBtnIcon from '@/assets/icons/front/menu-btn.svg';
import Image from 'next/image';

type Props = {};

const HeaderHamburger : React.FC<Props> = () : ReactElement | null => {
    const { showMobileMenu, setShowMobileMenu } = useContext(HeaderContext);

    return (
        <Button
            type='empty'
            onClick={() => {
                setShowMobileMenu(!showMobileMenu);
            }}
            className='flex lg:hidden h-auto !py-0 !px-0 items-center'
        >
            {
                showMobileMenu
                    ? <Image src={menuCloseBtnIcon} alt='Menu Close Icon' width='16' height='16' />
                    : <Image src={menuBtnIcon} alt='Menu Open Icon' width='16' height='16' />
            }
        </Button>
    );
};

export default HeaderHamburger;
